/**
 * 메뉴 화면 → 챗 라우트 모듈.
 *
 * 챗 요청은 `/api/v1/scenario/{module}/chat` 로 나간다. 그 module 은 화면이 다루는 업무
 * 영역이다(SUPPORTED_CHAT_MODULES 와 같은 값). 예전에는 시나리오 플래닝 화면만 자기 코드를
 * 발행하고 나머지는 전부 GENERAL 로 갔는데, "자원 생산 계획"처럼 시나리오 화면은 아니지만
 * 특정 모듈의 담당 화면인 것들이 그 때문에 모듈 지식까지 잃었다(어느 모듈에도 속하지
 * 않는다고 답했다).
 *
 * 화면에 시나리오 단계·액션이 있는지는 별개 축이라 payload 의 scenario_planning 이 나른다.
 * 여기서 정하는 것은 "어느 모듈의 챗이냐"뿐이다.
 *
 * 판정 재료는 App 의 plannel:navScreen({current:true}) 응답이 준다(lv1Key·reduxKey).
 * 화면마다 무언가를 선언할 필요가 없도록 메뉴 계층에서 파생한다.
 */

// lv1 메뉴가 곧 업무 영역인 것들. 그 아래 화면 전부가 같은 모듈이다.
const LV1_CHAT_MODULE = {
  DEMAND_PLAN:        "DP",
  INVENTORY_PLAN:     "IP",
  REPLENISHMENT_PLAN: "RP",
  MASTER_PLAN:        "MP",
};

// 수요예측(BF)은 전용 lv1 이 없다 — 수요계획 lv1 아래에 DP 화면과 섞여 있어서
//   lv1 만으로는 갈리지 않는다. 이 화면들만 lv3 로 덮어쓴다.
const LV3_CHAT_MODULE = {
  BF_REVIEW:          "BF",
  BF_LEADERBOARD:     "BF",
  BF_ACCURACY_REPORT: "BF",
  FEATURE_ANALYSIS:   "BF",
};

/**
 * 현재 화면을 담당하는 챗 모듈 코드(BF/DP/IP/RP/MP) 또는 null.
 *
 * 매핑에 없으면 null 이다 — 호출부가 GENERAL 로 떨어뜨린다. 모르는 화면에 모듈을 씌우면
 * 그 모듈의 담당 화면인 것처럼 답하게 되므로, 없는 쪽이 안전한 기본값이다.
 */
export const resolveChatModule = (screenNav) => {
  if (!screenNav?.ok) return null;
  return LV3_CHAT_MODULE[screenNav.reduxKey] ?? LV1_CHAT_MODULE[screenNav.lv1Key] ?? null;
};
